export default {
    USERS_SET_USERS_LOADING: 'USERS_USERS_SET_USERS_LOADING',
    USERS_SET_SELECTED_USER: 'USERS_SET_SELECTED_USER',
    USERS_SET_SELECTED_PARTNER: 'USERS_SET_SELECTED_PARTNER',
    USERS_SET_SELECTED_GENERAL_PARTNER: 'USERS_SET_SELECTED_GENERAL_PARTNER',
    USERS_SET_SEARCH_USER: 'USERS_SET_SEARCH_USER',
    USERS_SET_SEARCH_PARTNER: 'USERS_SET_SEARCH_PARTNER',
    USERS_SET_FILTER_PARTNER: 'USERS_SET_FILTER_PARTNER',
    USERS_SET_FILTER_APPLICATION: 'USERS_SET_FILTER_APPLICATION',
    USERS_SET_MODE_USER_MODAL: 'USERS_SET_MODE_USER_MODAL',
    USERS_SET_MODE_PARTNER_MODAL: 'USERS_SET_MODE_PARTNER_MODAL',
    USERS_SET_MODE_GENERAL_MODAL: 'USERS_SET_MODE_GENERAL_MODAL',
    USERS_SET_SHOW_USER_MODAL: 'USERS_SET_SHOW_USER_MODAL',
     USERS_SET_SHOW_PARTNER_MODAL: 'USERS_SET_SHOW_PARTNER_MODAL',
    USERS_SET_SHOW_GENERAL_MODAL: 'USERS_SET_SHOW_GENERAL_MODAL',
    USERS_SET_SHOW_USERS: 'USERS_SET_SHOW_USERS',
    USERS_SET_SHOW_EDIT_USER: 'USERS_SET_SHOW_EDIT_USER',
    USERS_RESET_STATE: 'USERS_RESET_STATE',
    USERS_SET_SHOW_UNLINK_MODAL: 'USERS_SET_SHOW_UNLINK_MODAL',
    USERS_SET_MAIN_EMAIL_MODAL: 'USERS_SET_MAIN_EMAIL_MODAL',
    USERS_SET_MAIN_EMAIL_SHOW_MODAL: 'USERS_SET_MAIN_EMAIL_SHOW_MODAL',
    USERS_SET_MAIN_EMAIL_SELECTED_USER: 'USERS_SET_MAIN_EMAIL_SELECTED_USER'
};